<mat-dialog-content>
  <div class='cls-div'>
    <button id='clsBtn' class='cls-btn' mat-icon-button (click)='onClsBtnClick()'>
      <mat-icon style='margin: 0px;'>close</mat-icon>
    </button>
  </div>
  <div class='div-stl'>
    <mat-icon id='icon' svgIcon='qm' style='height: 50px; width: 50px;'></mat-icon>
  </div>
  <h1 id='message' class='title' mat-dialog-title>{{data.message}}</h1>
  <div>
    <div id='hint' class='information' [innerHTML]='data.hint'></div>
  </div>
  <div class="status-options">
    <div >
      <div class="row">
        <mat-radio-group
          (change)="selectedStateChanged($event.value)"
          [value]="selectedState"
          color="accent"
        >
          <p>Status unklar:</p>
          <mat-radio-button
            *ngFor="let unclearState of unclearStates"
            [value]="unclearState"
          >
            {{ unclearState | endIncidentStatusLabel : 'internal'}}
          </mat-radio-button>

          <p>Die LS leuchtet wieder:</p>
          <mat-radio-button
            *ngFor="let faultFixedState of faultFixedStates"
            [value]="faultFixedState"
          >
            {{ faultFixedState | endIncidentStatusLabel : 'internal'}}
          </mat-radio-button>

          <p>Störungsbehebung ist nicht möglich:</p>
          <mat-radio-button
            *ngFor="let notPossibleState of notPossibleStates"
            [value]="notPossibleState"
          >
            {{ notPossibleState | endIncidentStatusLabel : 'internal'}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>
  <div class="hint-box">
    <b>Hinweis</b>
    <p style="margin-top: 10px;">Bitte diese Funktion ausschließlich nutzen, wenn eine Störung nach wieder Eröffnung erneut geschlossen wird oder bei einer offenen Störung definitiv keine Antwort mehr zu erwarten ist.</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='div-stl' style='padding-bottom: 30px;'>
    <button id='btn1' *ngIf='data.button' class='nd-btn nd-btn-outline btn-fnt btn-spc' style='width: 160px;'
            mat-raised-button (click)='onRevokeBtnClick()'> {{data.button}} </button>
    <button id='btn2' *ngIf='data.button2' class='nd-btn nd-btn-main btn-fnt btn-spc' style='width: 160px;'
            mat-raised-button (click)='onConfirmBtnClick()'> {{data.button2}} </button>
  </div>
</mat-dialog-actions>
